import $ from "jquery";

(function ($) {
  const heroVideoPlayButton = (function () {
    let buttons = $(document).find("[data-videoplayer-btn]");
    let players = $(document).find("[data-videoplayer]");

    buttons.on("click", function () {
      let targetID = $(this).attr("data-videoplayer-btn");
      let player = $('[data-videoplayer="' + targetID + '"]');
      player.removeAttr("hidden");
    });

    players.on("click", function (e) {
      console.log($(this));
      if (!e.target.getAttribute("data-videoplayer")) {
        return;
      }

      $(this).attr("hidden", true);
      $(this).find("video").get(0).pause();
    });
  })();
})(jQuery);
